import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type { GetTaskStatusRequest, GetTaskStatusResponse } from './dto';
import { TasksAPIRoutes } from './route';

export function getStatus(params: GetTaskStatusRequest): Promise<GetTaskStatusResponse> {
  return makeRequest(api.get(TasksAPIRoutes.getTaskStatus(), { params }));
}
